<body>
  
  <div class="d-lg-flex half">
    <div class="bg order-1 order-md-2" style="background-image: url('assets/images/login_bg.jpg');"></div>
    <div class="contents order-2 order-md-1">
      <div class="container">

        <div class="row  justify-content-center">

         <img class="justify-content-center mt-2"  src="assets/images/logo.png" width="225px" height="160px"> 

          <div class="col-md-10">
            <form [formGroup] ="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
              <div class="form-group">
                <label for="username">Username</label>
                <input type="text" formControlName="username" class="form-control" placeholder="Your Username"   [class.is-invalid]="formErrors.username" (blur)="logValidationErrors()">
                <span class="text-danger pt-2" *ngIf="formErrors.username"><small>{{formErrors.username}}</small></span> 
              </div>
              <div class="form-group mb-3">
                <label for="password">Password</label>
                <input type="password" formControlName="password"  class="form-control" [class.is-invalid]="formErrors.password" (blur)="logValidationErrors()" placeholder="Your Password">
                <span class="text-danger" *ngIf="formErrors.password"><small>{{formErrors.password}}</small> </span> 
                <span class="text-danger" *ngIf="isInvalidData && !formErrors.password"><small>{{invalidMessage}}</small></span> 
              </div>
              
              <div class="d-flex mb-5 align-items-center">
                <label class="control control--checkbox mb-0"><span class="caption">Keep me logged in</span>
                  <input type="checkbox" formControlName="rememberMe"/>
                  <div class="control__indicator"></div>
                </label>
                <span class="ml-auto"><a routerLink="/reset-password-request"  class="forgot-pass">Forgot Password</a></span> 
              </div>

              <button [disabled]="!loginForm.valid" 
              [ngClass]="{'loginBtnActive' : loginForm.valid,'loginBtnDisabled' : !loginForm.valid }"
               type="submit" class="btn btn-lg btn-block btn-primary">
             <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              LOG IN
             </button>

            </form>
          </div>
        </div>
      </div>
    </div>

    
  </div>
    
     <!-- Form Values : {{ loginForm.value | json }}   -->

  </body>
